export const messages = {
    "wr-dashboard.search.input.hint": "Procurar",
    "wr-dashboard.search.label.breadcrumb": "Resultados da pesquisa",
    "wr-dashboard.search.message.empty": "A sua pesquisa não obteve correspondências",
    "wr-dashboard.side-bar.selected.title:plural": "{count} itens selecionados | {count} item selecionado | {count} itens selecionados",
    "wr-dashboard.side-bar.backup-type.disk": "Disco",
    "wr-dashboard.side-bar.backup-type.file": "Ficheiro",
    "wr-dashboard.side-bar.backup-type.notarized": "Ficheiros autenticados e pastas",
    "wr-dashboard.side-bar.backup-type.exchange": "Aplicação - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Aplicação - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Aplicação - Estado do sistema",
    "wr-dashboard.side-bar.backup-type.application": "Aplicação",
    "wr-dashboard.backups-table.column.name": "Nome",
    "wr-dashboard.backups-table.column.size": "Tamanho",
    "wr-dashboard.backups-table.column.version": "Última versão",
    "wr-dashboard.backups-table.action.delete": "Eliminar",
    "wr-dashboard.backups-table.message.no-backups": "Ainda não existem backups na Nuvem",
    "wr-dashboard.backups-sidebar.label.size": "Tamanho",
    "wr-dashboard.backups-sidebar.label.type": "Tipo",
    "wr-dashboard.backups-sidebar.label.version": "Última versão",
    "wr-dashboard.backups-sidebar.label.created": "Criado",
    "wr-dashboard.backups-sidebar.label.machine": "Máquina",
    "wr-dashboard.backups-sidebar.label.owner": "Proprietário",
    "wr-dashboard.content-table.column.name": "Nome",
    "wr-dashboard.content-table.column.versions": "Versões",
    "wr-dashboard.content-table.column.volumes": "Volumes",
    "wr-dashboard.content-table.column.path": "Caminho",
    "wr-dashboard.content-table.column.size": "Tamanho",
    "wr-dashboard.content-table.column.version": "Última versão",
    "wr-dashboard.content-table.action.notary-verify": "Verificar",
    "wr-dashboard.content-table.action.notary-get-crt": "Obter certificado",
    "wr-dashboard.content-table.action.asign": "Enviar para assinatura",
    "wr-dashboard.content-table.action.versions": "Versões",
    "wr-dashboard.content-table.action.restore": "Transferir",
    "wr-dashboard.content-table.label.size": "Tamanho",
    "wr-dashboard.content-table.label.created": "Criado",
    "wr-dashboard.content-table.label.modified": "Modificação",
    "wr-dashboard.content-table.message.empty-folder": "Esta pasta está vazia",
    "wr-dashboard.password-dialog-box.title.backup": "Cópia de segurança encriptada",
    "wr-dashboard.password-dialog-box.title.archive": "Arquivo encriptado",
    "wr-dashboard.password-dialog-box.message.backup": "Especifique a palavra-passe para aceder ao backup {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Especifique a palavra-passe para aceder ao arquivo {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Palavra-passe",
    "wr-dashboard.password-dialog-box.message.invalid-password": "A palavra-passe está incorreta",
    "wr-dashboard.form.button.open": "Abrir",
    "wr-dashboard.form.button.close": "Fechar",
    "wr-dashboard.form.button.cancel": "Cancelar",
    "wr-dashboard.form.button.continue": "Continuar",
    "wr-dashboard.form.button.proceed": "Continuar",
    "wr-dashboard.form.button.delete": "Eliminar",
    "wr-dashboard.form.button.done": "Concluído",
    "wr-dashboard.form.button.retry": "Repetir",
    "wr-dashboard.notary.verify.view.status.downloading": "A transferir...",
    "wr-dashboard.notary.verify.view.status.validating": "A validar...",
    "wr-dashboard.notary.verify.view.status.pending": "Certificado pendente...",
    "wr-dashboard.notary.verify.view.status.fail": "Erro de correspondência de certificado...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Obter certificado",
    "wr-dashboard.notary.verify.view.file-info.name": "NOME",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "ASSINADO POR",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "FOI CRIADO UM BACKUP DOS DADOS",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "OS DADOS FORAM AUTENTICADOS",
    "wr-dashboard.notary.verify.view.button.cancel": "Cancelar",
    "wr-dashboard.notary.verify.view.button.done": "Concluído",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Versão de browser não suportada",
    "wr-dashboard.versions-dialog-box.title": "Versões de {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Enviar para assinatura",
    "wr-dashboard.asign-dialog-box.message": "A versão do ficheiro é partilhada, mas ninguém pode ver o ficheiro sem a ligação para o mesmo. Utilize o ASign para adicionar signatários e partilhar a ligação.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Mostrar detalhes do ficheiro",
    "wr-dashboard.page-not-found.title": "Página não encontrada",
    "wr-dashboard.page-not-found.message.main": "A página que procura não foi encontrada.",
    "wr-dashboard.page-not-found.message.description": "A ligação pode estar desatualizada ou o endereço pode estar incorreto.",
    "wr-dashboard.page-not-found.message.error": "Código de erro: 404",
    "wr-dashboard.server-error.title": "O servidor não está disponível",
    "wr-dashboard.server-error.message": "O servidor não está atualmente disponível. Tente novamente mais tarde.",
    "wr-dashboard.server-error.message.error": "Código de erro: 500",
    "wr-dashboard.account-menu.action.sign-out": "Terminar sessão",
    "wr-dashboard.breadcrumb.item.machines": "Máquinas",
    "wr-dashboard.breadcrumb.item.failed-backups": "Backups com falhas",
    "wr-dashboard.machines-table.column.name": "Nome",
    "wr-dashboard.machines-table.column.size": "Tamanho",
    "wr-dashboard.machines-table.message.no-machines": "Ainda não existem máquinas na Nuvem",
    "wr-dashboard.incomplete-backups.message.status:plural": "Tem {count} backups com falhas ou incompletos a ocupar {size} de armazenamento | Tem {count} backup com falhas ou incompleto a ocupar {size} de armazenamento | Tem {count} backups com falhas ou incompletos a ocupar {size} de armazenamento",
    "wr-dashboard.incomplete-backups.button.view": "Ver backups",
    "wr-dashboard.incomplete-backups.button.delete": "Eliminar backups",
    "wr-dashboard.machines-table.message.space-used:plural": "Utilização total de backups {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Eliminar arquivos",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Eliminar arquivos incompletos",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Eliminar todos os arquivos incompletos",
    "wr-dashboard.delete-archive.message": "Tem a certeza de que pretende eliminar definitivamente os arquivos selecionados de todas as localizações? Todos os dados serão eliminados e não poderão ser restaurados.",
    "wr-dashboard.certificate-pending-dialog-box.title": "O certificado está pendente",
    "wr-dashboard.certificate-pending-dialog-box.message": "Tente novamente dentro de alguns minutos.",
    "wr-dashboard.form.button.ok": "OK"
};
